<script>
/**
 * Portal — renders its slot into a div appended directly to document.body.
 *
 * Why: CSS `transform` on an ancestor creates a new containing block for
 * `position:fixed` elements, breaking viewport-fixed positioning. By moving
 * the slot's DOM node to <body>, it sits above all transforms.
 *
 * Usage:
 *   <portal v-if="open">
 *     <div class="my-floating-thing" style="position:fixed; ...">...</div>
 *   </portal>
 *
 * Vue 2 guarantee: once a child component's $el is moved, the parent's
 * patch cycle never re-inserts it — only `updateChildComponent` is called,
 * which updates props/slots without touching DOM placement.
 */
export default {
  name: 'Portal',
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  render(h) {
    // Wrap slot in a neutral div so we own a stable $el.
    // The slot content (position:fixed) escapes the div visually.
    return h('div', { style: 'display:contents' }, this.$slots.default);
  },
};
</script>
